import { motion } from 'framer-motion';
import { CalendarCheck, Sparkles, Heart } from 'lucide-react';

const STEPS = [
  {
    num: '01',
    icon: CalendarCheck,
    title: 'Request your free quote',
    body: 'Tell us about your space — home, office, restaurant or retail — and pick a cleaning schedule that suits you. We reply fast with a clear, no-pressure quote.',
  },
  {
    num: '02',
    icon: Sparkles,
    title: 'We clean, top to bottom',
    body: 'Our trained, insured team arrives on time with eco-friendly products and a proven checklist — every room, every surface, every visit.',
  },
  {
    num: '03',
    icon: Heart,
    title: 'Enjoy the sparkle',
    body: 'Walk through, approve the results, and relax. Recurring plans keep your home or workplace looking day-one fresh, week after week.',
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="bg-ceramic py-24 lg:py-36 border-t border-stone-200/70">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl mb-16">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-mint mb-5">02 — How It Works</p>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.7 }}
            className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight text-obsidian leading-[1.05]"
          >
            The easiest chore
            <br />
            on your list.
          </motion.h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.num}
              data-testid={`step-card-${s.num}`}
              initial={{ opacity: 0, y: 36 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className="relative rounded-3xl bg-white border border-stone-200/80 p-8 lg:p-9 transition-all duration-500 hover:-translate-y-1.5 hover:shadow-xl hover:shadow-obsidian/5 h-full flex flex-col"
            >
              <div className="flex items-center justify-between mb-7">
                <span className="w-12 h-12 rounded-full bg-mint-light flex items-center justify-center">
                  <s.icon size={20} className="text-mint" />
                </span>
                <span className="font-display font-extrabold text-5xl text-mint/20 leading-none">
                  {s.num}
                </span>
              </div>
              <h3 className="font-display font-bold text-obsidian text-xl lg:text-2xl tracking-tight">
                {s.title}
              </h3>
              <p className="mt-3 text-stone-600 text-sm lg:text-base leading-relaxed flex-1">
                {s.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
